export const state = {
  /**
   * Weather we are viewing in favourite mode or not
   * In favourite mode only favourites are shown
   */
  favouriteMode: false,

  /**
   * An object storing the details of all the favourite requests that are being sent
   * Which includes, the id and type of the favourite which we are trying to add
   * Format
   * {
   *    '[type][id]': true/false
   * }
   */
  sendingFavRequest: {}
};
